export const getPaymentMethodText = (paymentMethod) => {
  if (!paymentMethod) return;

  const paymentMethods = {
    pix: 'Pix',
    boleto: 'Boleto',
    credit_card: 'Cartão de Crédito',
    bank_slip_yapay: 'Boleto',
    billet: 'Boleto',
    cash: 'Dinheiro',
    hybrid: 'Híbrido',
    pix_automatic: 'Pix',
    wallet: 'Wallet',
  };

  return paymentMethods[paymentMethod.toLowerCase()];
};

export const getPurchaseGroupStatusText = (groupStatus) => {
  if (groupStatus === 'sell') return 'Pago';
  if (groupStatus === 'refunded') return 'Reembolsado';
};

export const getPurchaseGroupStatusColor = (groupStatus) => {
  if (groupStatus === 'sell') return 'green';
  if (groupStatus === 'refunded') return 'red';
  return 'grey';
};
